import { isEmpty, trim } from 'lodash';
import { isEmail, isEmailPatsnap, isPhoneNumber } from './validate';
import { separatorRe } from './regex';
export function splitEmailOrPhoneNumbers(content) {
    const parts = [];
    const errors = [];
    let hasMobile = false;
    let hasEmail = false;
    content = trim(content);
    if (content) {
        const contentAry = content.split(separatorRe);
        for (let i = 0; i < contentAry.length; i++) {
            const part = trim(contentAry[i]);
            if (part === '') {
                continue;
            }
            if (isEmail(part)) {
                hasEmail = true;
                parts.push(part);
            }
            else if (isPhoneNumber(part)) {
                hasMobile = true;
                parts.push(part);
            }
            else {
                errors.push(part);
            }
        }
    }
    return {
        parts,
        errors,
        hasMobile,
        hasEmail,
    };
}
export function splitEmailGroup(emailsStr) {
    const emails = [];
    const errors = [];
    emailsStr = trim(emailsStr);
    if (!emailsStr) {
        return {
            emails,
            errors,
        };
    }
    const emailsAry = emailsStr.split(separatorRe);
    for (let i = 0; i < emailsAry.length; i++) {
        const email = trim(emailsAry[i]);
        if (email === '') {
            continue;
        }
        if (isEmail(email)) {
            emails.push(email);
        }
        else {
            errors.push(email);
        }
    }
    return {
        emails,
        errors,
    };
}
export function splitEmailGroupByEnter(emailsStr) {
    const emails = [];
    const errors = [];
    emailsStr = trim(emailsStr);
    if (!emailsStr) {
        return {
            emails,
            errors,
        };
    }
    // 只通过换行符分割，支持\n和\r\n
    const emailsAry = emailsStr.split(/\r?\n/);
    for (let i = 0; i < emailsAry.length; i++) {
        const email = trim(emailsAry[i]);
        if (email === '') {
            continue;
        }
        if (isEmail(email)) {
            emails.push(email);
        }
        else {
            errors.push(email);
        }
    }
    return {
        emails,
        errors,
    };
}
export function splitPatsnap(emailsStr) {
    const emails = [];
    const errors = [];
    emailsStr = trim(emailsStr);
    if (!emailsStr) {
        return {
            emails,
            errors,
        };
    }
    const emailsAry = emailsStr.split(separatorRe);
    for (let i = 0; i < emailsAry.length; i++) {
        const email = trim(emailsAry[i]);
        if (email === '') {
            continue;
        }
        if (isEmailPatsnap(email)) {
            emails.push(email);
        }
        else {
            errors.push(email);
        }
    }
    return {
        emails,
        errors,
    };
}
/**
 * split姓名、邮箱、手机号
 * @param str
 * @returns
 */
export function splitAccountGroup(str) {
    const accounts = [];
    str = trim(str);
    if (!str) {
        return accounts;
    }
    const accountsAry = str.split(separatorRe);
    for (let i = 0; i < accountsAry.length; i++) {
        const account = trim(accountsAry[i]);
        if (isEmpty(account)) {
            continue;
        }
        accounts.push(account);
    }
    return accounts;
}
